import { render } from "./UnderstandingDigu.vue?vue&type=template&id=7aa060b3&scoped=true"
import script from "./UnderstandingDigu.vue?vue&type=script&lang=js"
export * from "./UnderstandingDigu.vue?vue&type=script&lang=js"

import "./UnderstandingDigu.vue?vue&type=style&index=0&id=7aa060b3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7aa060b3"]])

export default __exports__